<template>
    <div class="page">
        <p>{{ date }}</p>
        <p style="display: inline-block;">
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p style="display: inline-block; float: right;">
            {{ creditBureau.address_name }}
            <br />
            {{ address.street }}
            <br />
            {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
        </p>
        <p class="letter-content">
            To Whom It May Concern
            I’m writing to let you know that I’d like to opt out for all pre-screened offers. Under FCRA (Fair Credit Reporting Act)
            all consumer reporting agencies must comply with this request. To verify that you’ve received this letter and processed
            my request, please send a letter stating as much.
        </p>
        <p>
                My <strong> details are as follows:</strong> <br />
            <strong>FULL NAME:</strong> {{ userStore.user.firstname }} {{ userStore.user.lastname }} <br />
            <strong>DATE OF BIRTH:</strong> {{ userStore.user.dob }}<br />
            <strong>SOCIAL SECURITY NUMBER: </strong> {{ userStore.user.ssn }} <br />
            <strong>PHONE NUMBER: </strong> {{ userStore.user.phone }} <br />
            <strong>FULL CURRENT ADDRESS: </strong> {{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p class="letter-content">
            <br />
            Sincerely, <br />
        </p>
        <template v-if="userStore.user.ssn_image_url || userStore.user.identity_image_url || userStore.user.address_verify_image_url">
            <div style="page-break-before: always;" class="page-content">
                <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
                <template v-if="userStore.user.identity_image_url">
                    <img :src='userStore.user.identity_image_url' width='400' />
                    <br />
                </template>
                <template v-if="userStore.user.address_verify_image_url">
                    <img :src='userStore.user.address_verify_image_url' width='400' />
                    <br />
                </template>
                <template v-else-if="userStore.user.ssn_image_url">
                    <img :src='userStore.user.ssn_image_url' width='400' />
                    <br />
                </template>
            </div>
        </template>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
